import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationLink } from '@domgen/dgx-fe-common';

@Component({
  selector: 'dgx-ui-wl-header-powered-by',
  templateUrl: './header-powered-by.component.html',
  styleUrls: ['./header-powered-by.component.scss'],
})
export class HeaderPoweredByComponent {
  /**
   * Accepts a single navigationLink
   */
  @Input() navigationLink!: NavigationLink;
  /**
   * Emits a click event back to the parent component
   */
  @Output() clicked: EventEmitter<MouseEvent> = new EventEmitter();

  /**
   * Listens and fires emit `clicked` when clicked
   */
  onClick(e: MouseEvent) {
    this.clicked.emit(e);
  }
}
